import React, { useState,useEffect,useRef } from 'react'
//import './FilterForm.css'
import {localestr,validate_ex_mark} from '../utils.js'
import icon from '../icons.svg' 


function LongTextForm({capt,value,setModal,action,is_liter=true}){
  const targetRef = useRef()
  let lastVol='0.5'
  const [val,setVal]=useState(parse(value))
  const [vol,setVol]=useState(lastVol)
  const [red,setRed]=useState(false)
  const [excise,setExcise]=useState('')

    function parse(d){
      let newVal=[]
      let tmpVal=[]
      if(d) tmpVal=d.split("\n")
      for(let i=0;i<tmpVal.length;i++){
        const pos=tmpVal[i].indexOf(';')
        let newItem=null
        if(pos!==-1) newItem={mark:tmpVal[i].substring(0,pos),vol:tmpVal[i].substring(pos+1)}
        else newItem={mark:tmpVal[i]}
        if(newItem.vol) lastVol=newItem.vol
        if(newItem.mark) newVal.push(newItem)
      }
      return newVal
    }

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
  
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWnd')
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    function keyClick(e){
      //console.log(e)
      if(e.key==='Enter' && e.shiftKey) {setModal('');action(val)}
      else if(e.key==='Escape') {setModal('');action(null)}
    }

    function keyClickInp(e){
      if(e.key==='Enter') {
        const newVal=val.map(el=>({...el,red:false}))
        const mark=e.target.value
        if(mark.length!==10){setRed(true);setTimeout(()=>setRed(false),2000);return}
        const idx=newVal.findIndex(el=>el.mark===mark)
        if(idx!==-1) newVal[idx].red=true
        else if(is_liter) newVal.push({mark,vol})
        else newVal.push({mark})
        setVal(newVal)
        setExcise('')
      }
    }

    function set_Val(idx,d){
      const newVal=val.map(el=>({...el,red:false}))
      newVal[idx].mark=validate_ex_mark(d)
      setVal(newVal)
    }

    function keyClickArr(idx,e){
      if(e.key==='Enter') {
        const newVal=val.map(el=>({...el,red:false}))
        if(val[idx].mark.length===10){
          const mark=newVal[idx].mark
          const idx2=newVal.findIndex((el,i)=>el.mark===mark&&i!==idx)
          if(idx2!==-1){
            newVal[idx].red=true
            newVal[idx2].red=true
          } else {
            const inp=document.getElementById('exc')
            if(inp) inp.focus()
          }
        } else if(val[idx].mark.length===0){
          newVal.splice(idx,1)
          const inp=document.getElementById('exc')
          if(inp) inp.focus()
        }
        setVal(newVal)
      }
    }

    function keyClickVol(e){
      if(e.key==='Enter') {
        const inp=document.getElementById('exc')
        if(inp) inp.focus()
      }
    }

    function delArr(idx){
      const newVal=val.map(el=>({...el,red:false}))
      newVal.splice(idx,1)
      setVal(newVal)
      const inp=document.getElementById('exc')
      if(inp) inp.focus()
    }

    function modVol(idx,vl,lost_focus=true){
      if(idx===-1) setVol(vl)
      else{
        if(idx+1===val.length)setVol(vl)
        const newVal=val.map(el=>({...el,red:false}))
        newVal[idx].vol=vl
        setVal(newVal)
        //if(vl==='1'||vl==='0.75'||vl==='0.7'||vl==='0.5') lost_focus=true
      }
      if(!vl){
        setTimeout(()=>{const inp=document.getElementById('vl'+idx);if(inp) inp.focus()},300)
      } else if(lost_focus) {
        const inp=document.getElementById('exc')
        if(inp) inp.focus()
      }
    }

    function getVol(idx){
      if(!is_liter) return null
      if(idx===-1){
        if(vol==='1'||vol==='0.75'||vol==='0.7'||vol==='0.5'){
          return <select value={vol} onChange={(e)=>{setVol(e.target.value)}} style={{width:'65px'}}><option value={1}>1л</option><option value={0.75}>0.75л</option><option value={0.7}>0.7л</option><option value={0.5}>0.5л</option><option value=''>{localestr('ввести')}</option></select>
        }
        return <div style={{display:'inline-block',width:'65px'}}><input id={'vl'+idx} type='number' value={vol} onChange={(e)=>{setVol(e.target.value,false)}} onKeyUp={keyClickVol} style={{width:'45px'}}/>л</div>
      }
      const vl=val[idx].vol
      if(vl==='1'||vl==='0.75'||vl==='0.7'||vl==='0.5'){
        return <select value={vl} onChange={(e)=>{modVol(idx,e.target.value)}} style={{width:'65px'}}><option value={1}>1л</option><option value={0.75}>0.75л</option><option value={0.7}>0.7л</option><option value={0.5}>0.5л</option><option value=''>{localestr('ввести')}</option></select>
      }
      return <div style={{display:'inline-block',width:'65px'}}><input id={'vl'+idx} type='number' value={vl} onChange={(e)=>{modVol(idx,e.target.value,false)}} onKeyUp={keyClickVol} style={{width:'45px'}}/>л</div>
    }

    function join(d){
      if(!d) return ''
      let newVal=''
      for(let i=0; i<d.length; i++){
        if(!d[i].mark) continue
        if(newVal) newVal+="\n"
        newVal+=d[i].mark
        if(is_liter&&d[i].vol) newVal+=';'+d[i].vol
      }
      if(excise.length===10){
        if(newVal) newVal+="\n"
        newVal+=excise
        if(is_liter&&vol) newVal+=';'+vol
      }
      return newVal
    }

    useEffect(() => {
      if(targetRef.current) targetRef.current.focus()
    // eslint-disable-next-line 
    },[])

    const stl1={padding:'0 2px'}
    const stl2={padding:'1px 3px',width:'90px'}
    const stl3={padding:'1px 3px',width:'90px',color:'red'}

    const ttl=val.reduce((a, c) =>{return a + parseFloat(c.vol)},0)

    return(
      <div className='modal_f'><div id='modalWnd' className='window'>
          <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{capt}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
          <div className='content'>
          <div onKeyUp={keyClick} style={{margin:'3px 0 0 0',display:'flex',justifyContent:'center'}}>
          <table style={{border:'none',borderCollapse:'collapse'}}><tbody>
            {val.map((el,idx)=>
              <tr key={idx}><td style={stl1}>{idx+1}</td><td style={stl1}>
              <input onKeyUp={e=>keyClickArr(idx,e)} type='text' value={el.mark} onChange={e=>{set_Val(idx,e.target.value)}} style={el.red?stl3:stl2}/>
              </td><td style={stl1}>{getVol(idx)}
              <img src={icon+'#canBut'} alt='' style={{margin:'-3px 0 -5px 0',width:'22px',height:'22px',cursor:'pointer'}} onClick={()=>delArr(idx)}/></td></tr>
            )}
            <tr><td style={stl1}></td><td style={stl1}><input onKeyUp={keyClickInp} id='exc' type='text' value={excise} onChange={e=>setExcise(validate_ex_mark(e.target.value))} ref={targetRef} style={red?stl3:stl2}/></td>
            <td style={stl1}>{ttl?localestr('Разом ')+ttl.toFixed(2)+localestr('л'):getVol(-1)}</td></tr>
          </tbody></table>
          </div>
          <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
          <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('');action(join(val))}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
          <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
          </div></div>
      </div></div>
    )
}

export default LongTextForm